import type { ItemsResponse } from "../../tastyworks"
import type HttpClient from "../../tastyworks/http"
import {
  ZERO_HASH_SUBDIVISION_DESER,
  ZeroHashSubdivision,
} from "../../tastyworks/zero-hash-subdivision"

export class ZeroHashSubdivisionService {
  constructor(private readonly baseHttpClient: HttpClient) {}

  readonly index = async (
    countryCode: string
  ): Promise<ItemsResponse<ZeroHashSubdivision>> =>
    this.baseHttpClient.indexSimple<ZeroHashSubdivision>(
      ZERO_HASH_SUBDIVISION_DESER.toParser(ZeroHashSubdivision),
      "zero-hash-subdivisions",
      { countryCode }
    )
}
